import { useTheme } from "@mui/material";
const Fieldset = (props) => {
    const theme = useTheme();

    return (
        <fieldset
            style={{
                borderRadius: theme.shape.borderRadius,
                backgroundColor: theme.palette.background.paper,
                border: '1px solid #ced4da',
                transition: theme.transitions.create(['border-color', 'box-shadow']),
                marginTop: props.label ? -13 : 0
                // ':focus': {
                //     borderRadius: 4,
                //     borderColor: '#80bdff',
                //     boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
                // },
            }}
            {...props}
        >
        </fieldset>
    )
}
export default Fieldset;